import React from "react";
import './PatientIntakeForm.css';

const LegendHorizontal = () => (
    <div className="legend-horizontal-box">
    <div className="legend-items-horizontal">
        <span className="legend-item">
        <strong className="legend-label">N</strong> - No
        </span>
        <span className="legend-item">
        <strong className="legend-label">P</strong> - Past
        </span>
        <span className="legend-item">
        <strong className="legend-label">C</strong> - Current
        </span>
    </div>
    </div>
);

export default LegendHorizontal;
